import { createSlice } from '@reduxjs/toolkit';
import { isEmpty } from '../modules/appLibrary';

const initialState = {
    open:false,
    type: 0,
    message: "",
    doCommand:[],
    doCommand2: [],
    doCancel: [],
    btnlabel1:"",
    btnlabel2: ""
};

const msgboxSlice = createSlice({
    name: 'msgbox',
    initialState,
    reducers: {
        warnmsg: (state, action) => {
            return Object.assign({}, state, { open: true, type: 0, message: action.payload})
        },
        infomsg: (state, action) => {
            return Object.assign({}, state, { open: true, type: 3, message: action.payload.msg, doCommand: action.payload.cmd })
        },
        confmsg: (state, action) => {
            if (isEmpty(action.payload.label1) ) 
                return Object.assign({}, state, { open: true, type: 1, message: action.payload.msg, doCommand: action.payload.cmd, doCancel: action.payload.cancel })
            else
                return Object.assign({}, state, { open: true, type: 1, message: action.payload.msg, doCommand: action.payload.cmd, doCancel: action.payload.cancel, btnlabel1: action.payload.label1 })
        },
        confmsg2: (state, action) => {
            if (isEmpty(action.payload.label1) || isEmpty(action.payload.label2)){
                return Object.assign({}, state, { open: true, type: 2, message: action.payload.msg, doCommand: action.payload.cmd, doCommand2: action.payload.cmd2 })
            } else {
                return Object.assign({}, state, {
                    open: true, type: 2, message: action.payload.msg,
                    doCommand: action.payload.cmd, doCommand2: action.payload.cmd2,
                    btnlabel1: action.payload.label1, btnlabel2: action.payload.label2
                })
            }
        },
        closemsg: (state, action) => {
            return Object.assign({}, state, { open:false, type: 0, message: "" })
        }
    },
});

export const {
    warnmsg, confmsg, confmsg2, closemsg, infomsg
} = msgboxSlice.actions

export default msgboxSlice;

